module.exports = __webpack_public_path__ + "static/media/usuario1.009f8710.png";